import { STATUS, PHASES } from '@/entities/imports'
import Data from './data'

export default {
    list: ({ params }) => [200, Data.imports],
    create: ({ params }) => [200, {
        data: {
            ...Data.imports.data[0],
            status: STATUS.running,
            numErrors: 1,
            numWarnings: 2,
        },
    }],
    get: id => [200, {
        data: {
            ...Data.imports.data[0],
            status: STATUS.pendingReview,
            phase: PHASES.VALIDATION,
            numErrors: 0,
            numWarnings: 0,
        },
    }],
    getSource: ({ params }) => [200, Data.source],
    editSource: ({ params }) => [200, {
        data: {
            globalIssues: [],
            rowIssues: [],
            cellIssues: [
                {
                    type: 'text',
                    level: 'error',
                    message: 'Found match at row 1 for rule levenshtein:name,hqCountry (10 options)',
                    row: 3,
                    field: 'name',
                },
            ],
        },
    }],
}
